import {Component, Input, ViewChild, ElementRef} from '@angular/core';
import {AuthService} from '../shared/services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {isDefined} from '../shared/utils/utils';
import {WebmateOptions} from '@webmate-web-core/webmate-options';
import {skip} from 'rxjs';
import {extractReturnUrl} from '@webmate-web-core/shared/utils/route-access';


@Component({
    selector: 'wm-login-sso',
    styleUrls: ['./login-sso.component.less'],
    templateUrl: './login-sso.component.html'
})
export class LoginSSOComponent {

    email: string = '';
    authRealm: string;
    fetchingAuthRealm: boolean = true;
    // original location where the user wanted to navigate to
    returnUrl: string;
    loggingIn: boolean = false;
    loginFailure: boolean = false;

    migrateUser = false;

    constructor(private authService: AuthService, private route: ActivatedRoute, private webmateOptions: WebmateOptions,
                private router: Router) {
    }

    checkForm() {
        return this.email.trim() === '';
    }


    ngOnInit() {
        // for chrome autofill bug
        let event;
        if (typeof (Event) === 'function') {
            event = new Event('resize');
        } else {
            event = document.createEvent('Event');
            event.initEvent('resize', true, true);
        }
        window.dispatchEvent(event);
        setTimeout(() => window.dispatchEvent(event), 300); // just to be sure

        this.returnUrl = extractReturnUrl(this.route.snapshot.queryParams);

        this.migrateUser = !!this.route.snapshot.queryParamMap.get('migrateUser');

        // In the regular SSO workflow we want to redirect the user to webmate as soon as the auth token is available
        // While setting up SSO for a user, we want them only to be redirected having the new SSO auth token
        // This new token will be emitted as auth info as soon as the SSO login is completed, so we need to skip the first token we encounter
        this.authService.observeAuthStatus().pipe(skip(this.migrateUser ? 1 : 0)).subscribe(
            result => {
                if (result) {
                    this.router.navigateByUrl(this.returnUrl).catch(err => {
                        this.router.navigate(['/']);
                    }).then((success) => {
                        if (success === false) {
                            this.router.navigate(['/']);
                        }
                    });
                }
            });

        this.authService.getAuthRealmForDomain(window.location.hostname).subscribe(realm => {
                this.authRealm = realm;
                this.fetchingAuthRealm = false;
                this.submitLogin();
            },
            error => {
                this.authRealm = undefined;
                this.fetchingAuthRealm = false;
            });
    }

    getRealmFromEmail(email: string) {
        return email.split('@')[1];
    }

    computeRealm(): string {
        return this.authRealm || this.getRealmFromEmail(this.email);
    }

    submitLogin() {
        this.loggingIn = true;
        window.open(this.webmateOptions.ssoHelperUrl + `?migrateUser=${this.migrateUser}&realm=` + this.computeRealm(), '_blank', 'height=500,width=800');
    }
}
